<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/Layout/Header/LayoutHeaderAccount.vue
// changes:
// change size of account icon

const customerStore = useCustomerStore();
const { signedIn } = storeToRefs(customerStore);
</script>

<template>
    <LocaleLink
        :to="signedIn ? '/account' : '/account/login'"
        class="flex items-center gap-2"
    >
        
<FormKitLazyProvider config-file="true">
<FormKitIcon
            class="block h-6 w-6"
            icon="user"
        />
</FormKitLazyProvider>

    </LocaleLink>
</template>
